const CheckedInToday = ({checkedInToday, onBaselineClick}) => {
  return (
    <div className='checked-in-section'>
      <div className='checked-in-info'>
        <div className='checked-in-circle'>
          <span className='checked-in-number'>{checkedInToday}</span>
        </div>
        <div className='checked-in-text'>
          <h2>Employees</h2>
          <h2>Checked In</h2>
          <h2>Today</h2>
        </div>
      </div>

      <button className='baseline-compliance-button' onClick={onBaselineClick}>
        Enrollment Baseline Compliance
      </button>
    </div>
  );
};

export default CheckedInToday;
